/* eslint-disable */
import { IsNotEmpty } from 'class-validator';

export class AccessFormData {
    @IsNotEmpty()
    email: string;

    @IsNotEmpty()
    password: string;
}
